import { Effect } from "../../Materials/effect";
var name = 'logDepthFragment';
var shader = "#ifdef LOGARITHMICDEPTH\ngl_FragDepthEXT=log2(vFragmentDepth)*logarithmicDepthConstant*0.5;\n#endif";
Effect.IncludesShadersStore[name] = shader;
/** @hidden */
export var logDepthFragment = { name: name, shader: shader };
//# sourceMappingURL=logDepthFragment.js.map